import { render, staticRenderFns } from "./MenuAreas.vue?vue&type=template&id=66898b28&scoped=true"
import script from "./MenuAreas.vue?vue&type=script&lang=js"
export * from "./MenuAreas.vue?vue&type=script&lang=js"
import style0 from "./MenuAreas.vue?vue&type=style&index=0&id=66898b28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66898b28",
  null
  
)

export default component.exports